import React from "react";
import { Button } from "@mui/material";
import PropTypes from "prop-types";

function ButtonComponent({
  title,
  handleButtonClick,
  Icon,
  cssName,
  enableSearchBtn,
}) {
  return (
    <div className="b-btn-container">
      <Button
        className={`b-btn-container__${cssName}`}
        variant="outlined"
        onClick={handleButtonClick}
        disabled={enableSearchBtn}
      >
        <p className="b-btn-container__icon">{Icon}</p>
        {title}
      </Button>
    </div>
  );
}
ButtonComponent.propTypes = {
  title: PropTypes.string.isRequired,
  Icon: PropTypes.node.isRequired,
  handleButtonClick: PropTypes.func.isRequired,
  cssName: PropTypes.string.isRequired,
  enableSearchBtn: PropTypes.bool,
};
ButtonComponent.defaultProps = {
  enableSearchBtn: true,
};
export default ButtonComponent;
